import { Flex, HStack, Switch, Text, useColorModeValue } from "@chakra-ui/react";
import { FilterToggle } from "./fhir-section";

interface ToggleFilterProps {
  filters: FilterToggle[];
  activeFilters: FilterToggle[];
  toggleFilter: (label: string, isChecked: boolean) => void;
}

function ToggleFilter({ filters, activeFilters, toggleFilter }: ToggleFilterProps) {
  const borderColor = useColorModeValue("gray.200", "gray.700");
  return (
    <Flex border="solid" borderRadius={"30px"} borderColor={borderColor} gap={2} px={5} py={2}>
      {filters.map((filter: FilterToggle) => (
        <HStack key={filter.label} fontWeight={"medium"}>
          <Text>{filter.label}</Text>
          <Switch
            isChecked={!!activeFilters.find((f: FilterToggle) => f.label === filter.label)}
            onChange={e => toggleFilter(filter.label, e.target.checked)}
            colorScheme={"blue"}
            size="md"
          />
        </HStack>
      ))}
    </Flex>
  );
}

export default ToggleFilter;
